/* eslint-disable */
import React, { useEffect, useState } from 'react';
import styles from './B2bAccordionSection.module.css';

export default function B2bAccordionSection({
  title,
  children,
  defaultOpen = false,
  className = '',
  lazyMount = false,
  onOpenChange,
  headerHref,
}) {
  const [open, setOpen] = useState(defaultOpen);
  const [everOpened, setEverOpened] = useState(defaultOpen);

  useEffect(() => {
    onOpenChange?.(open);
  }, [open, onOpenChange]);

  const toggle = () => {
    setOpen(prev => {
      const next = !prev;
      if (next) setEverOpened(true);
      return next;
    });
  };

  const handleHeaderClick = () => {
    if (headerHref) {
      window.location.href = headerHref;
      return;
    }
    toggle();
  };

  const showBody = !headerHref && (lazyMount ? everOpened : true);

  return (
    <section className={`${styles.section}${className ? ` ${className}` : ''}`}>
      <button
        type="button"
        className={styles.header}
        aria-expanded={headerHref ? undefined : open}
        onClick={handleHeaderClick}
      >
        <span className={styles.title}>{title}</span>
        <span className={styles.chevron} aria-hidden>
          {headerHref ? '→' : open ? '−' : '+'}
        </span>
      </button>
      {showBody ? (
        <div className={`${styles.body}${open ? '' : ` ${styles.bodyHidden}`}`} hidden={!open}>
          {children}
        </div>
      ) : null}
    </section>
  );
}
